import { render, staticRenderFns } from "./tabLeads.vue?vue&type=template&id=18762b48&scoped=true"
import script from "./tabLeads.vue?vue&type=script&lang=js"
export * from "./tabLeads.vue?vue&type=script&lang=js"
import style0 from "./tabLeads.vue?vue&type=style&index=0&id=18762b48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18762b48",
  null
  
)

export default component.exports